import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripTags',
    standalone: true
})
export class StripTagsPipe implements PipeTransform {

  transform(value: string|null): string {
    return value?.replace(/(<([^>]+)>)/gi, '');
  }

}
